<template>
    <BCard v-if="section">
        <BRow>
            <BCol cols="12">
                <h4 class="mb-2">{{ $t("General data") }}</h4>
            </BCol>
            <BCol cols="12" xl="6">
                <table class="mt-2 mt-xl-0 w-100">
                    <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="section.name" />
                </table>
            </BCol>
        </BRow>
    </BCard>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue';
import { onUnmounted, ref } from '@vue/composition-api';
import ViewData from '@/components/ViewData.vue';
import sectionsModule from '../sectionsModule';
import popups from '@/hooks/popups';
import router from '@/router';
import store from '@/store';

export default {
    components: { BCard, BRow, BCol, ViewData },
    setup(){
        const { deletePopup } = popups()
        const SECTION_MODULE = 'sections'
        const section = ref(null)

        if(!store.hasModule(SECTION_MODULE)) store.registerModule(SECTION_MODULE, sectionsModule)

        onUnmounted(() => {
            if(store.hasModule(SECTION_MODULE)) store.unregisterModule(SECTION_MODULE)
        })

        store.dispatch('sections/fetchSection', { id: router.currentRoute.params.id } ).then(response => {
            section.value = response.data.section
        })

        return {
            deletePopup,
            section,
        }
    }
}
</script>
<style lang="scss">
@import 'src/assets/scss/variables/_variables.scss';
table tr th {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>